import { App } from 'vue'
import initElement from './element'
// 全局组件插件
import initGlobComp from './glob-comp'

// export default function (app: App) {
export function initPlugin(app: App) {
	initElement(app)
	initGlobComp(app)
}
